<!-- this component is deprecated -->
<template>
  <div class="form_container">
    <b-container fluid>
      <b-row>
        <b-col cols="12" style="text-align:center;color:#2C2A29;font-size:16px;font-weight: 500;">
          CADASTRO DE COMPRADOR
        </b-col>
        <b-col cols="12" style="text-align:center;letter-spacing:-2.2px;" :style="{color: getCssColor('primary_bt')}">
          __________________
        </b-col>
        <b-col cols="12" style="text-align:center;color:#2C2A29;font-size:16px;margin-top:15px;font-weight: 500;">
          Os campos com * são obrigatórios, você receberá um SMS/Email de ativação.
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIconasterisk" :icon="['far', 'asterisk']" :style="{color: getCssColor('primary_bt')}"/>
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'user']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateName()" :class="{invalidForm: invalidName}" class="inputFormText" name="name" placeholder="Nome" v-model="name"/>
          <div v-if="invalidName" class="messageInputError">{{messageErrorName}}</div>
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIconasterisk" :icon="['far', 'asterisk']" :style="{color: getCssColor('primary_bt')}"/>
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'user']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateFamilyName()" :class="{invalidForm: invalidFamilyName}"  class="inputFormText" name="familyName" placeholder="Sobrenome" v-model="familyName"/>
          <div v-if="invalidFamilyName" class="messageInputError">{{messageErrorFamilyName}}</div>
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIconasterisk" :icon="['far', 'asterisk']" :style="{color: getCssColor('primary_bt')}"/>
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'envelope']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateEmail()" :class="{invalidForm: invalidEmail}"  class="inputFormText" name="email" placeholder="E-mail" autocapitalize="off" autocorrect="off" v-model="email"/>
          <div v-if="invalidEmail" class="messageInputError">{{messageErrorEmail}}</div>
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIconasterisk" :icon="['far', 'asterisk']" :style="{color: getCssColor('primary_bt')}"/>
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'key']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="password" @blur="validatePassword()" :class="{invalidForm: invalidPassword}"  class="inputFormText" name="password" placeholder="Senha" autocapitalize="off" autocorrect="off" v-model="password"/>
          <div v-if="invalidPassword" class="messageInputError">{{messageErrorPassword}}</div>
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIconasterisk" :icon="['far', 'asterisk']" :style="{color: getCssColor('primary_bt')}"/>
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'key']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="password" @blur="validatePassword2()" :class="{invalidForm: invalidPassword2}" class="inputFormText" name="password2" placeholder="Repetir Senha" autocapitalize="off" autocorrect="off" v-model="password2"/>
          <div v-if="invalidPassword2" class="messageInputError">{{messageErrorPassword2}}</div>
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIconasterisk" :icon="['far', 'asterisk']" :style="{color: getCssColor('primary_bt')}"/>
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'mobile-android-alt']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validatePhone()" :class="{invalidForm: invalidPhone}" class="inputFormText" name="mobile" placeholder="Celular com DDD - Ex: 11 999999999" v-model="phone"/>
          <div v-if="invalidPhone" class="messageInputError">{{messageErrorPhone}}</div>
        </b-col>
        <b-col cols="12">
          <font-awesome-icon class="imgInputIconasterisk" :icon="['far', 'asterisk']" :style="{color: getCssColor('primary_bt')}"/>
          <font-awesome-icon class="imgInputIcon" :icon="['fal', 'credit-card-blank']" :style="{color: getCssColor('primary_bt')}"/>
          <input type="text" @blur="validateCpf()" :class="{invalidForm: invalidCpf}" class="inputFormText" name="familyName" placeholder="CPF" v-model="cpf"/>
          <div v-if="invalidCpf" class="messageInputError">{{messageErrorCpf}}</div>
        </b-col>
        <b-col cols="12">
          <div style="border-bottom: 1px solid #2C2A29;width:100%;margin:20px 0 0 0;">
          <font-awesome-icon class="imgSelectIcon" :icon="['fal', 'user']" :style="{color: getCssColor('primary_bt')}"/>
            <select class="selectFormText" v-model.number="gender">
              <option value="0">Sexo (escolha)</option>
              <option value="1">Masculino</option>
              <option value="2">Feminino</option>
            </select>
            <div v-if="invalidGender" class="messageInputError">{{messageErrorGender}}</div>
          </div>
        </b-col>
        <b-col cols="12">
          <b-row style="color:#2C2A29;margin-top:20px;">
            <b-col cols="1">
              <font-awesome-icon style="margin-left:5px;margin-top:8px;" :icon="['fal', 'birthday-cake']" :style="{color: getCssColor('primary_bt')}"/>
            </b-col>
            <b-col cols="3">
              <select class="selectFormData" v-model.number="birthDay">
                <option value="0">Dia</option>
                <option v-for="(n, idx) in 31" :value="n" v-bind:key="idx">{{n}}</option>
              </select>
            </b-col>
            <b-col cols="3">
              <select class="selectFormData" v-model.number="birthMonth">
                <option value="0">Mês</option>
                <option v-for="(n, idx) in 12" :value="n" v-bind:key="idx">{{n}}</option>
              </select>
            </b-col>
            <b-col cols="4">
              <select class="selectFormData" v-model.number="birthYear">
                <option value="0">Ano</option>
                <option v-for="(n, idxa) in years" :value="n" v-bind:key="idxa">{{n}}</option>
              </select>
            </b-col>
          </b-row>
        </b-col>
        <b-col cols="12">
          <div v-if="invalidBirth" class="messageInputError">{{messageErrorBirth}}</div>
        </b-col>

        <b-col cols="12" style="text-align:center;color:#2C2A29;font-size:14px;font-weight: 500;margin:15px auto;">
          <input type="checkbox" @blur="validateAgreed()" :class="{invalidForm: invalidAgreed}" v-model="agreed"/> Declaro que li e concordo com os <a :href="'https://s3.amazonaws.com/cdnopa4/img/img/' + $store.state.company.companyId + '/privacy/termo.pdf'" target="_blank" style="color:#2C2A29!important;text-decoration:underline;">Termos de Uso</a> e <a :href="'https://s3.amazonaws.com/cdnopa4/img/img/' + $store.state.company.companyId + '/privacy/privacy.pdf'" target="_blank" style="color:#2C2A29!important;text-decoration:underline;">Política de Privacidade</a>
          <div v-if="invalidAgreed" class="messageInputError">{{messageErrorAgreed}}</div>
        </b-col>
        <b-col cols="12">
          <div @click="register()" :style="{backgroundColor: getCssColor('primary_bt')}"
            style="margin-top:20px;color:#FFFFFF; cursor:pointer; font-size:14px; font-weight:500; border-radius:4px; height:40px;line-height:40px;text-align:center;">
            CONTINUAR
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import colors from '@/mixins/colors'
import UserConn from '@/connection/user'
import { EventBus } from '@/behaviours/event-bus'
// import DatePicker from 'vue2-datepicker'

export default {
  name: 'RegisterForm',
  data () {
    return {
      name: null,
      invalidName: false,
      messageErrorName: 'O campo nome é obrigatório',
      familyName: null,
      invalidFamilyName: false,
      messageErrorFamilyName: 'O campo sobrenome é obrigatório',
      email: null,
      invalidEmail: false,
      messageErrorEmail: 'O campo email é obrigatório',
      password: null,
      invalidPassword: false,
      messageErrorPassword: 'O campo senha é obrigatório, precisa ter 6 dígitos',
      password2: null,
      invalidPassword2: false,
      messageErrorPassword2: 'As senhas não conferem',
      phone: null,
      invalidPhone: false,
      messageErrorPhone: 'O campo celular é obrigatório, insira o DDD seguido do número. Ex: 11 999999999',
      cpf: null,
      invalidCpf: false,
      messageErrorCpf: 'O campo CPF é obrigatório para compras no Brasil',
      gender: 0,
      invalidGender: false,
      messageErrorGender: 'O campo sexo é obrigatório',
      birthDay: null,
      birthMonth: null,
      birthYear: null,
      invalidBirth: false,
      messageErrorBirth: 'A data de aniversário é obrigatória',
      agreed: true,
      invalidAgreed: false,
      messageErrorAgreed: 'O campo concordo com os temos é obrigatório'
    }
  },
  mixins: [colors],
  // components: {DatePicker},

  computed: {
    years () {
      let years = []
      let currentYearLess = Number(new Date().getFullYear()) - 12 // no one less than 12 years old and older than 90
      for (let x=0; x < 91; x++){
        years.push(currentYearLess - x)
      }
      return years
    }
  },

  methods: {
    async register () {
      if (this.validateForm()) {
        this.$store.state.showLoading = true
        let birth = null
        if (this.birthDay && this.birthMonth && this.birthYear) {
          let btday = new Date()
          btday.setFullYear(Number(this.birthYear))
          btday.setMonth(Number(this.birthMonth) - 1)
          btday.setDate(Number(this.birthDay))
          birth = btday.getTime().toString()
        }
        let result = await UserConn.register(
          this.name.trim(),
          this.familyName.trim(),
          this.email.toLowerCase().trim(),
          '+55' + this.phone.replace(/[^0-9]+/g, '').toString(),
          this.cpf.replace(/[^0-9]+/g, '').toString(),
          this.gender = (this.gender === 1 ? 'masculino' : 'feminino'),
          this.password,
          birth)
        if (!result.error) {
          this.$store.state.showLoading = false
          this.$router.push({path:'/validation'})
        } else {
          EventBus.$emit('showAlert', 'error', result.error)
          this.$store.state.showLoading = false
        }
      }
    },

    validateForm () {
      if (!this.validateName() &&
          !this.validateFamilyName() &&
          !this.validateEmail() &&
          !this.validatePassword() &&
          !this.validatePassword2() &&
          !this.validatePhone() &&
          !this.validateCpf() &&
          !this.validateAgreed() &&
          !this.validateBirth() &&
          !this.validateGender()
      ) {
        return true
      } else {
        return false
      }
    },
    validateBirth () {
      //this.invalidBirth = !(this.birthDay && this.birthMonth && this.birthYear)
      return false
    },
    validateGender () {
      //this.invalidGender = !this.gender
      return false
    },
    validateName () {
      this.invalidName = !this.name || this.name.length < 3
      return this.invalidName
    },
    validateFamilyName () {
      this.invalidFamilyName = !this.familyName || this.familyName.length < 3
      return this.invalidFamilyName
    },
    validateEmail () {
      this.invalidEmail = !this.email || this.email.indexOf('@') === -1 || this.email.length < 3
      return this.invalidEmail
    },
    validatePassword () {
      this.invalidPassword = !this.password || this.password.length < 6
      return this.invalidPassword
    },
    validatePassword2 () {
      this.invalidPassword2 = !this.password2 || this.password2 !== this.password
      return this.invalidPassword2
    },
    validatePhone () {
      this.invalidPhone = !this.phone || this.phone.replace(/[^0-9]+/g, '').toString().length < 10
      return this.invalidPhone
    },
    validateCpf () {
      this.invalidCpf = !this.cpf || this.cpf.replace(/[^0-9]+/g, '').toString().length < 11 || !this.validateCpfDigits(this.cpf.replace(/[^0-9]+/g, '').toString())
      return this.invalidCpf
    },
    validateAgreed () {
      this.invalidAgreed = !this.agreed || this.agreed === false
      return this.invalidAgreed
    },

    validateCpfDigits (strCPF) {
      let sum
      var rest
      sum = 0
      if (strCPF == '00000000000'){
        return false
      }
      for (let i = 1; i <= 9; i++) {
        sum = sum + parseInt(strCPF.substring(i-1, i)) * (11 - i)
      }
      rest = (sum * 10) % 11
      if ((rest == 10) || (rest == 11)){
        rest = 0
      }
      if (rest != parseInt(strCPF.substring(9, 10)) ){
        return false
      }
      sum = 0
      for (let i = 1; i <= 10; i++) {
        sum = sum + parseInt(strCPF.substring(i-1, i)) * (12 - i)
      }
      rest = (sum * 10) % 11
      if ((rest == 10) || (rest == 11)) {
        rest = 0
      }
      if (rest != parseInt(strCPF.substring(10, 11) ) ) {
        return false
      }
      return true
    }

  }
}
</script>

<style lang="scss" scoped>
.form_container {
  position:relative;
  width: calc(100%);
  max-width:500px;
  margin: 0px auto;

  input::placeholder {
    font-size:16px;
    //color: #2C2A29;
  }

  input:focus {
    outline: none;
    border:0px;
    border-bottom: 1px solid #5E2B8B;
  }

  select:focus {
    outline: none;
    border: 1px solid #2C2A29;
    border-radius: 4px;
  }

  .inputFormText {
    width: calc(100%);
    font-size:16px;
    height:30px;
    padding-left:40px;
    color: #2C2A29;
    border:0px;
    border-bottom: 1px solid #2C2A29;
  }


  .selectFormText {
    width: calc(100% - 30px);
    font-size:16px;
    height:30px;
    padding-left:10px;
    color: #2C2A29;
    border: 0px;
    margin-left:10px;
  }

  .selectFormData {
    width:100%;
    font-size:16px;
    height:30px;
    color: #2C2A29;
    border:1px solid #2C2A29;
    border-radius: 4px;
  }


  .imgInputIcon {
    position:relative;
    left:8px;
    top:26px;
    font-size:16px;
  }

  .imgInputIconasterisk {
    position:relative;
    left:5px;
    top:22px;
    font-size:8px;
  }

  .imgSelectIcon {
    font-size:16px;
    margin-left:5px;
  }

}

.messageInputError {
  color: rgb(255, 88, 88);
  font-size:12px;
  padding:4px;
}

.invalidForm {
  border-bottom: 1px solid rgb(255, 88, 88)!important;
}
</style>
